import axios from '@/utils/request'
// 获取应用列表
export const getAppList = (params)=>{
  return axios.request({
    url: 'v1/appsServe/lists',
    method: 'get',
    params
  })
}
// 获取年限应用详情
export const getAppDetail = (params)=>{
  return axios.request({
    url: 'v1/appsServe/detailForYear',
    method: 'get',
    params
  })
}
// 获取服务应用详情
export const getAppDetailForServe = (params)=>{
  return axios.request({
    url: 'v1/appsServe/detailForServe',
    method: 'get',
    params
  })
}
// 立即抢购 - 购买
export const appBuy = (data)=>{
  return axios.request({
    url: 'v1/appsServe/appBuy',
    method: 'post',
    data
  })
}
// 立即抢购 - 续费
export const appRenewal = (data)=>{
  return axios.request({
    url: 'v1/appsServe/appRenewal',
    method: 'post',
    data
  })
}
// 立即抢购 - 订单详情
export const getAppOrder = (params)=>{
  return axios.request({
    url: 'v1/appsServe/orderDetail',
    method: 'get',
    params
  })
}
// 立即抢购 - 支付二维码
export const getPayCode = (params)=>{
  return axios.request({
    url: 'v1/appsServe/getPayCode',
    method: 'get',
    params
  })
}
//余额支付
export const  payForBalance= (data)=>{
  return axios.request({
     url: 'v1/appsServe/payByBalance',
     method: 'POST',
     data
  })
};

//应用列表
export const  appsServeLists= (data)=>{
  return axios.request({
     url: 'v1/appsServe/lists',
     method: 'get',
     data
  })
};



//续费年限列表
export const  appRenewInfo= ()=>{
  return axios.request({
     url: 'v1/appsServe/app_renew_info',
     method: 'get',
  })
};

//应用详情
export const  appInfo= (id)=>{
  return axios.request({
     url: 'v1/appsServe/appInfo/'+id,
     method: 'get',
  })
};


//应用开通
export const  appsServeBuy= (data)=>{
  return axios.request({
     url: 'v1/appsServe/appBuy',
     method: 'post',
     data
  })
};

//应用开通年限计算价格
export const  appRenewCountPrice= (data)=>{
  return axios.request({
     url: 'v1/appsServe/app_renew_count_price',
     method: 'post',
     data
  })
};

export const appsServeRenewal= (data)=>{
  return axios.request({
     url: 'v1/appsServe/appRenewal',
     method: 'post',
     data
  })
};




